function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useRef, useEffect, useState, useContext } from 'react';
import hljs from 'highlight.js';
import { useTheme } from '@emotion/react';
// Lucide React 아이콘들
import { Clipboard } from 'lucide-react';
import { Check } from 'lucide-react';
import { MessageSquarePlus } from 'lucide-react';
import { FilePlus } from 'lucide-react';
import { Send } from 'lucide-react';
// 의존성 imports
import { IdeMessengerContext } from '@edusense/features-ide-messenger';
import { isVSCodeEnvironment } from '@edusense/shared-utils';
// 로컬 imports
import { useElementWidth } from './hooks';
import { CodeContainer, TopBar, LanguageName, CopyButton, SelectionSendButton, COMPACT_THRESHOLD_CODE_PX } from './styles';
import { createCopyHandler, createPasteSelectedTextToChatHandler, createPasteToChatHandler, createPasteToEditorHandler, createMouseUpHandler } from './handlers';
/**
 * 풀 사이즈 코드 블록 컴포넌트
 * 구문 하이라이팅, 복사 기능, VSCode 통합 기능을 제공하는 완전한 코드 블록
 */ var FullCodeBlock = function(param) {
    var className = param.className, language = param.language, codeString = param.codeString;
    var theme = useTheme();
    var codeContainerRef = useRef(null);
    var codeRef = useRef(null);
    // 상태 관리
    var isCompact = useElementWidth(codeContainerRef, COMPACT_THRESHOLD_CODE_PX);
    var _useState = _sliced_to_array(useState(false), 2), isCopied = _useState[0], setIsCopied = _useState[1];
    var _useState1 = _sliced_to_array(useState(null), 2), selectedText = _useState1[0], setSelectedText = _useState1[1];
    var _useState2 = _sliced_to_array(useState(null), 2), selectionPosition = _useState2[0], setSelectionPosition = _useState2[1];
    // Context 및 환경 감지
    var ideMessenger = useContext(IdeMessengerContext);
    var isVSCode = isVSCodeEnvironment();
    // 이벤트 핸들러들
    var handleCopy = createCopyHandler(codeString, setIsCopied);
    var handlePasteSelectedTextToChat = createPasteSelectedTextToChatHandler(ideMessenger, language, setSelectedText, setSelectionPosition);
    var handlePasteToChat = createPasteToChatHandler(ideMessenger, codeString, language);
    var handlePasteToEditor = createPasteToEditorHandler(ideMessenger, language, codeString);
    var handleMouseUp = createMouseUpHandler(codeContainerRef, setSelectedText, setSelectionPosition);
    // Syntax highlighting 처리
    useEffect(function() {
        if (codeRef.current && language !== 'mermaid') {
            hljs.highlightElement(codeRef.current);
        }
        return function() {
            setSelectedText(null);
            setSelectionPosition(null);
        };
    }, [
        language,
        codeString
    ]);
    if (!codeString) return null;
    return /*#__PURE__*/ React.createElement(CodeContainer, {
        ref: codeContainerRef,
        onMouseUp: handleMouseUp
    }, /*#__PURE__*/ React.createElement(TopBar, null, /*#__PURE__*/ React.createElement(LanguageName, null, language === 'text' ? 'TEXT' : language.toUpperCase()), /*#__PURE__*/ React.createElement("div", null, isVSCode && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(CopyButton, {
        onClick: handlePasteToChat,
        title: "전체 코드 채팅에 붙여넣기"
    }, /*#__PURE__*/ React.createElement(MessageSquarePlus, {
        size: 14
    }), !isCompact && /*#__PURE__*/ React.createElement("span", null, "Chat All")), /*#__PURE__*/ React.createElement(CopyButton, {
        onClick: handlePasteToEditor,
        title: "실습 파일 생성"
    }, /*#__PURE__*/ React.createElement(FilePlus, {
        size: 14
    }), !isCompact && /*#__PURE__*/ React.createElement("span", null, "Editor"))), /*#__PURE__*/ React.createElement(CopyButton, {
        onClick: handleCopy,
        title: "클립보드에 복사"
    }, isCopied ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Check, {
        size: 14
    }), " ", !isCompact && /*#__PURE__*/ React.createElement("span", null, "Copied!")) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Clipboard, {
        size: 14
    }), " ", !isCompact && /*#__PURE__*/ React.createElement("span", null, "Copy"))))), selectedText && selectionPosition && isVSCode && /*#__PURE__*/ React.createElement(SelectionSendButton, {
        style: {
            top: "".concat(selectionPosition.top, "px"),
            left: "".concat(selectionPosition.left, "px")
        },
        onClick: function(e) {
            e.stopPropagation();
            handlePasteSelectedTextToChat(selectedText);
        },
        title: "선택 영역 채팅에 보내기"
    }, /*#__PURE__*/ React.createElement(Send, {
        size: 14
    }), /*#__PURE__*/ React.createElement("span", null, "Send Selected")), /*#__PURE__*/ React.createElement("pre", {
        style: {
            margin: 0
        }
    }, /*#__PURE__*/ React.createElement("code", {
        ref: codeRef,
        className: "language-".concat(language),
        style: {
            display: 'block',
            padding: theme.spacing.md,
            backgroundColor: theme.isDark ? '#1E1E1E' : theme.paperLight,
            color: theme.text,
            fontSize: theme.typography.fontSize.sm,
            lineHeight: '1.4',
            whiteSpace: 'pre-wrap',
            wordWrap: 'break-word'
        }
    }, codeString)));
};
export default FullCodeBlock;
